import { Search, Download } from "lucide-react";
import { downloadCsv } from "@/lib/api";

export const STATUS_STYLE = {
  pending: "text-yellow-400 border-yellow-400/30 bg-yellow-400/5",
  active: "text-emerald-400 border-emerald-400/30 bg-emerald-400/5",
  completed: "text-[#D4AF37] border-[#D4AF37]/30 bg-[#D4AF37]/5",
  rejected: "text-red-400 border-red-400/30 bg-red-400/5",
};

export const matches = (obj, q) => {
  if (!q) return true;
  const needle = q.toLowerCase();
  return Object.values(obj).some((v) => v != null && typeof v !== "object" && String(v).toLowerCase().includes(needle));
};

export const TableToolbar = ({ title, count, query, onQuery, placeholder, onExport, testId, children }) => (
  <div className="flex flex-wrap items-center justify-between gap-4 mb-8" data-testid={`${testId}-toolbar`}>
    <div>
      <h2 className="font-display text-2xl tracking-tight">{title}</h2>
      <p className="font-accent text-[9px] tracking-[0.2em] uppercase text-white/35 mt-1" data-testid={`${testId}-count`}>{count} records</p>
    </div>
    <div className="flex flex-wrap items-center gap-3">
      {children}
      <label className="flex items-center gap-2 border border-white/10 px-3 py-2 gold-focus">
        <Search size={13} className="text-white/40" />
        <input
          data-testid={`${testId}-search-input`}
          value={query}
          onChange={(e) => onQuery(e.target.value)}
          placeholder={placeholder}
          className="bg-transparent text-xs text-white placeholder:text-white/30 outline-none w-48"
        />
      </label>
      <button
        type="button"
        data-testid={`${testId}-export-button`}
        onClick={onExport}
        className="flex items-center gap-2 border border-[#D4AF37]/50 text-[#D4AF37] px-4 py-2 font-accent text-[10px] tracking-[0.2em] uppercase hover:bg-[#D4AF37] hover:text-black transition-colors"
      >
        <Download size={12} /> Export Excel
      </button>
    </div>
  </div>
);

export const exportRows = (name, columns, rows) => downloadCsv(`metrixworks-${name}-${new Date().toISOString().slice(0, 10)}.csv`, columns, rows);

export const Empty = ({ testId, text }) => <p className="px-6 py-8 text-sm text-white/40" data-testid={testId}>{text}</p>;
